import type { TokenResponse } from "@tandemdiabetes/sugarmate-api-react-client"
import { useNavigate } from "@tanstack/react-router"
import {
  useCallback,
  useMemo,
} from "react"

import { useOauthAuthorize } from "./useOauthAuthorize"
import { useOauthAuthorizeContext } from "src/contexts"
import { ReturningUserFlow } from "src/pages/SignIn"

export function OauthAuthorizeSignIn() {
  const navigate = useNavigate()
  const oauthAuthorize = useOauthAuthorize()

  const {
    p,
    device_type,
    client_id,
    redirect_uri,
  } = useOauthAuthorizeContext()

  const onSignIn = useMemo(
    () => !oauthAuthorize
      ? undefined
      : async (response: TokenResponse) => {
        await oauthAuthorize(response.access_token)
      },
    [oauthAuthorize],
  )

  const goBack = useCallback(
    () => {
      if (redirect_uri) {
        location.replace(redirect_uri)
      } else {
        void navigate({ to: "/oauth/authorize" })
      }
    },
    [
      navigate,
      redirect_uri,
    ],
  )

  return (
    <ReturningUserFlow
      p={p}
      deviceType={device_type}
      clientId={client_id}
      onSignIn={onSignIn}
      goBack={goBack}
      forgotPasswordRoute="/oauth/authorize/forgot_password"
      isOauth
    />
  )
}
